module.exports = __webpack_public_path__ + "static/media/淘淘@2x.10e7efe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/淘淘@2x.png
// module id = 657
// module chunks = 1